<template>
  <div id="auth">
    <div v-if="loading" id="preloader">
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <!-- Page Content -->
      <div class="page-content">
        <!-- Banner -->
        <div class="banner-wrapper shape-1">
          <div class="container inner-wrapper">
            <img src="assets/images/logo/logo-sm.png" class="mx-auto" />
            <h3 class="dz-title mt-2">Recupera tu contraseña</h3>
            <p class="mb-0">Encuentra tu cuenta de Reddy</p>
          </div>
        </div>
        <!-- Banner End -->
        <transition appear name="slide-fade">
          <div>
            <div class="container">
              <div v-if="!success" class="account-area">
                <form class="" v-on:submit.prevent="set_reset">
                  <div class="input-group">
                    <input
                      v-model="email"
                      type="text"
                      placeholder="Correo electrónico"
                      class="form-control"
                    />
                  </div>

                  <div class="input-group">
                    <button
                      type="submit"
                      class="btn mt-2 btn-primary w-100 btn-rounded"
                    >
                      Siguiente <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </form>

                <div>
                  <router-link
                    to="/auth"
                    class="btn btn-primary light btn-rounded text-primary d-block"
                    >Iniciar sesión</router-link
                  >
                  <router-link
                    to="/registro"
                    class="btn btn-primary light btn-rounded text-primary d-block mt-1"
                    >Crear mi cuenta</router-link
                  >
                </div>
              </div>
              <div v-else class="text-center">
                <div class="alert alert-primary p-3" style="font-size: 1.2em">
                  <i class="bx bxs-check-circle bx-sm"></i> <br />
                  Hemos enviado a la dirección de correo electrónico registrada
                  en tu membresía de Reddy las indicaciones para reactivar tu
                  contraseña. Revisa la bandeja de entrada y sigue las
                  instrucciones.
                </div>
                <router-link
                  to="/auth"
                  class="btn btn-primary light btn-rounded text-primary d-block"
                >
                  <i class="fa fa-chevron-left"></i> Regresar</router-link
                >
              </div>
            </div>
          </div>
        </transition>
      </div>
      <!-- Page Content End -->
      <!-- Footer -->
      <footer class="footer fixed"></footer>
      <!-- Footer End -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Password_reset",
  metaInfo: {
    title: "Recupera tu contraseña - Reddy App",
  },
  data() {
    return {
      loading: true,
      email: null,
      success: false,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_app");
    if (session != undefined) {
      this.$router.push("/");
      return false;
    }
  },
  methods: {
    set_reset: function () {
      if (this.email == null || this.email == "") {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu correo electrónico",
        });
        return false;
      }

      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        email: this.email,
      };
      const vm = this;
      axios
        .post(this.$base_url + "auth/password_reset", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            return false;
          }
          vm.success = true;
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>